export default function (input) {
    var eanNumber = Number(input)

    // Check if the conversion was successful and if the input length is 13
    return !isNaN(eanNumber) && input.length === 13
}
